import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import './WhatYouGet.css';

export type Tier = 'rawPhoto' | 'annotatedPhoto' | 'rawVideo';

const CONTENT: Record<Tier, { title: string; items: string[] }> = {
  rawPhoto: {
    title: 'What you get with Raw Photos',
    items: [
      'Original full-resolution image files (JPG/PNG)',
      'Foldered by Category / Subcategory / Item Type / Task',
      'manifest.json + CSV: taxonomy, image dimensions, capture date, language, tags',
      'README with dataset structure',
      'No labels or bounding boxes — see Annotated Photos',
    ],
  },
  annotatedPhoto: {
    title: 'What you get with Annotated Photos',
    items: [
      'Everything included in Raw Photos, at no extra cost',
      'Human-verified labels: class names + bounding boxes',
      'COCO format (annotations.json, absolute xywh)',
      'YOLO format (per-image .txt, normalized cxcywh)',
      'Image dimensions measured from the actual file bytes',
      'Label descriptors and class list',
    ],
  },
  rawVideo: {
    title: 'What you get with Raw Video',
    items: [
      'Original video clips (MP4)',
      'Foldered by Category / Subcategory / Item Type / Task',
      'manifest.json + CSV: taxonomy, clip duration, capture date, tags',
      'README with dataset structure',
      'No labels — annotated video is coming soon',
    ],
  },
};

export default function WhatYouGet({ tier }: { tier: Tier }) {
  const { colors } = useTheme();
  const [open, setOpen] = useState(false);
  const c = CONTENT[tier];

  return (
    <div className="wyg-panel" style={{ borderColor: colors.border, background: colors.card }}>
      <button
        className="wyg-head"
        onClick={() => setOpen((v) => !v)}
        style={{ color: colors.text }}
      >
        <span>{c.title}</span>
        <span className="wyg-chev" style={{ color: colors.secondary }}>{open ? '▾' : '▸'}</span>
      </button>
      {open && (
        <ul className="wyg-list" style={{ color: colors.secondary }}>
          {c.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
